<script>
// 加载中
import InnerLoading from "@/components/spinner/spinner.vue";
// 动态表单模版
import Temp from '@/components/technician/temp/index';
import {
  process_flowClassifiedQuery,
  processIncompletePersonalList,
  processNewdetails,
  // processRemove,
  processTaskHistorical,
  processUserUnclaimed,
} from "@/lib/request";
import sendEmail from "@/components/technician/sendEmail/index.vue";
export default {
  name: 'techTask',
  data() {
    return {
      // timer: null,
      // count: 0,
      downObj:{},
      flagEmail:false,
      innerLoading: false,
      searchText:'',
      dateFlag:true,
      statueFlag:false,
      itemStatue:0,
      statueTitle:'待处理',
      dataStatue:[
        {type:'0',title:'待处理'},
        {type:'2',title:'未完成'},
        // {type:'1',title:'已完成'},
      ],
      activeTab: '0',//'西藏-网点维护',
      typeFlag:false,
      itemType:0,
      typeTitle:'全部',
      typeState:'',//1、新装机，2、撤机、3、移机，4、信息更正，5、经营类型变更，6、网点录入、7、特殊巡检，8、巡检
      dataType:[
        {type:'',title:'全部'},
        {type:'1',title:'新装机'},
        {type:'2',title:'撤机'},
        {type:'3',title:'移机'},
        {type:'4',title:'信息更正'},
        {type:'5',title:'经营类型变更'},
        {type:'6',title:'网点录入'},
        {type:'7',title:'特殊巡检'},
        {type:'8',title:'巡检'},
      ],

      // 动态表单模版
      returnObj: {},
      formDefine: {},
      flowNameObj: {},
      formFields: [],
      historyList: [],
      flagTemp: false,
      newSiteId: '',
      submitText: '',
      variablesObj: {},

      // 列表数据
      page1: 0,//当前页
      size1: 10,//每页条数
      totals1: 0,//总条数
      totalPages1: 0,//总页数
      finished1: true,
      loading1: false,
      finishedMsgTxt: '没有更多了',
      inList: [],
      // 未完成

      page2: 0,//当前页
      size2: 10,//每页条数
      totals2: 0,//总条数
      totalPages2: 0,//总页数
      finished2: true,
      loading2: false,
      finishedMsgTxt2: '没有更多了',
      processHistory: [],
      //
      page_data: 0,//当前页
      size_data: 10,//每页条数
      totals_data: 0,//总条数
      totalPages_data: 0,//总页数
      finished_data: true,
      loading_data: false,
      finishedMsgTxt_data: '没有更多了',
      inList_data: []
    }
  },
  components: {
    sendEmail,
    InnerLoading,
    Temp
  },
  watch: {
    searchParams(newVal, oldVal) {
      if (newVal.category !== oldVal.category) {
        this.page1 = 0;
      }
      // this.getListData();
    },
    searchParams2() {
      if (this.activeTab === '1') {
        this.page2 = 0;
      }
      // this.getNoSuccessListData();
    },
    paramsSearch(newVal, oldVal) {
      if (newVal.state !== oldVal.state) {
        this.page_data = 0;
      }
      this.getFlowClassifiedQuery();
    },

  },
  computed: {
    // 监控参数变化更新
    searchParams() {
      return {
        size: this.size1,//每页数量
        page: this.page1,//当前页码
        category: '',//this.activeTab,
        // openId:this.user_openid,//
        // orderByColumn:'createTime',
        // isAsc:'asc',
        // state:this.activeTab//积分类型
      };
    },
    searchParams2() {
      return {
        size: this.size2,//每页数量
        page: this.page2,//当前页码
        // category: '',//this.activeTab,
        // openId:this.user_openid,//
        // orderByColumn:'createTime',
        // isAsc:'asc',
        // state:this.activeTab//积分类型
      };
    },
    paramsSearch() {
      return {
        size: this.size_data,//每页数量
        page: this.page_data,//当前页码
        search: this.searchText,//身份证号、网点编号、手机号
        flowType:this.typeState,//flowType(1、新装机，2、撤机、3、移机，4、信息更正，5、经营类型变更，6、网点录入、7、特殊巡检，8、巡检)不填写查所有
        // orderByColumn:'createTime',
        sort:this.dateFlag?'DESC':'ASC',// sort（“ASC”，“DESC”）不填写默认asc上，DESC下
        state:this.activeTab //（0、待领取，1、已完成，2、未完成）
      };
    },
  },
  created() {
    if (this.$route.query.active) {
      this.activeTab = this.$route.query.active
    }
    // 当前任务列表数据
    // this.getListData();
    // 未完成的任务列表
    // this.getNoSuccessListData();
    this.getFlowClassifiedQuery();

  },
  methods: {
    getEmailReturn(data){
      console.log('data',data)
    },
    getDownLoad(item){
      this.downObj = item;
      this.flagEmail = true
    },
    onLoad() {
      setTimeout(() => {
        if (this.page1 < this.totalPages1) {
          this.page1 = this.page1 + 1;
        }
      }, 1000);
    },
    onLoad2() {
      setTimeout(() => {
        if (this.page2 < this.totalPages2) {
          this.page2 = this.page2 + 1;
        }
      }, 1000);
    },
    onLoad_data() {
      setTimeout(() => {
        if (this.page_data < this.totalPages_data) {
          this.page_data = this.page_data + 1;
        }
      }, 1000);
    },
    hide(){
      this.statueFlag = false;
      this.typeFlag = false;
    },
    getSwitchDate(){
      this.page_data = 0;
      this.dateFlag = !this.dateFlag;
    },
    getSwitchStatue(){
      this.statueFlag = !this.statueFlag;
      if(this.typeFlag){
        this.typeFlag = false;
      }
    },
    getSwitchType(){
      this.typeFlag = !this.typeFlag;
      if(this.statueFlag){
        this.statueFlag = false;
      }
    },
    getCurrent(index,item){
      this.itemStatue = index;
      this.statueTitle = item.title;
      this.activeTab = item.type;
      this.statueFlag = !this.statueFlag
    },
    getTypeCurrent(index,item){
      this.itemType = index;
      this.typeTitle = item.title;
      this.typeState = item.type;
      // this.activeTab = item.type;
      this.typeFlag = !this.typeFlag
    },
    // 当前任务列表数据
    getListData() {
      this.loading1 = true;
      this.finished1 = false;
      if (this.searchParams.page === 0) {
        this.inList = [];
      }
      processUserUnclaimed(this.searchParams).then((res) => {
        if (res) {
          if (res.data) {
            this.loading1 = false;
            if (res.data.code === 200) {
              let resData = res.data.data.processBacklogTask;
              this.totals1 = res.data.data.total;
              this.totalPages1 = Math.ceil(res.data.data.total / this.size1) - 1;
              if (resData == null || resData.length === 0) {
                this.finished1 = true;
                this.inList = [];
                return false;
              } else {
                resData.map((v) => {
                  if (v.processInstanceName) {
                    if (v.processInstanceName.split('-') && v.processInstanceName.split('-').length > 1) {
                      v.arr_name = v.processInstanceName.split('-')[1];
                    } else {
                      v.arr_name = v.processInstanceName;
                    }
                  } else if (v.processDefinitionName) {
                    if (v.processDefinitionName.split('-') && v.processDefinitionName.split('-').length > 1) {
                      v.arr_name = v.processDefinitionName.split('-')[1];
                    } else {
                      v.arr_name = v.processDefinitionName;
                    }
                  }
                });
                if (this.page1 > 0) {
                  this.inList = this.inList.concat(resData);
                } else {
                  this.inList = resData;
                }
                // 总条数和每页条数
                if (this.totals1 < this.size1) {
                  this.finished1 = true;
                  return;
                }
                // 当前页和总页数
                if (this.page1 === this.totalPages1) {
                  this.finished1 = true;
                  return false;
                }
              }
            } else {
              this.$toast.fail(res.data.msg);
            }
          }
        }
      });
    },
    getNoSuccessListData() {
      this.loading2 = true;
      this.finished2 = false;
      if (this.searchParams2.page === 0) {
        this.processHistory = [];
      }
      processIncompletePersonalList(this.searchParams2).then((res) => {
        if (res) {
          // {
          //   "processInstanceName": "专管员-信息更正",
          //     "taskId": null,
          //     "category": "西藏-网点维护",
          //     "created": "2025-08-18 19:07:46",
          //     "endTime": null,
          //     "name": "渠道部审核",
          //     "assignee": "yu wei4141",
          //     "processInstanceId": "920c3b05-7c23-11f0-9685-fae678439206",
          //     "processDefinitionId": "zgz-xx gz:54:687ab589-7687-11f0-a50c-4a77aa16e9f2",
          //     "baseNo": "000000-XZ-WD WH-202508-00088",
          //     "baseName": "null",
          //     "variables": {
          //   "processInstanceId": "920c3b05-7c23-11f0-9685-fae678439206",
          //       "oldAddress": "西坝河临2号园",
          //       "city": "拉萨市-东郊片区",
          //       "startMethod": "manual",
          //       "currentOperator": "1935945614051274754",
          //       "initiator": "1935945614051274754",
          //       "tenantId": "000000",
          //       "siteid": "54010888",
          //       "BaseNo": "000000-XZ-WD WH-202508-00088",
          //       "newAddress": "w文化智库818号"
          // },
          //   "processHistoricInstanceOutput": null
          // }
          if (res.data) {
            this.loading2 = false;
            if (res.data.code === 200) {
              let resData = res.data.data.taskQueryOutputList;
              this.totals2 = res.data.data.totalCount;
              this.totalPages2 = Math.ceil(res.data.data.totalCount / this.size2) - 1;
              if (resData == null || resData.length === 0) {
                this.finished2 = true;
                this.processHistory = [];
                return false;
              } else {
                resData.map((v) => {
                  if (v.processInstanceName) {
                    if (v.processInstanceName.split('-') && v.processInstanceName.split('-').length > 1) {
                      v.arr_name = v.processInstanceName.split('-')[1];
                    } else {
                      v.arr_name = v.processInstanceName;
                    }
                  } else if (v.processDefinitionName) {
                    if (v.processDefinitionName.split('-') && v.processDefinitionName.split('-').length > 1) {
                      v.arr_name = v.processDefinitionName.split('-')[1];
                    } else {
                      v.arr_name = v.processDefinitionName;
                    }
                  }
                });
                if (this.page2 > 0) {
                  this.processHistory = this.processHistory.concat(resData);
                } else {
                  this.processHistory = resData;
                }
                // 总条数和每页条数
                if (this.totals2 < this.size2) {
                  this.finished2 = true;
                  return;
                }
                // 当前页和总页数
                if (this.page2 === this.totalPages2) {
                  this.finished2 = true;
                  return false;
                }
              }
            } else {
              this.$toast.fail(res.data.msg);
            }
          }
        }
      })
    },
    getFlowClassifiedQuery(){
      this.loading_data = true;
      this.finished_data = false;
      if (this.paramsSearch.page === 0) {
        this.inList_data = [];
      }
      process_flowClassifiedQuery(this.paramsSearch).then((response)=>{
        let res = response.data;
        if(res){
          this.loading_data = false;
          if(res.code===200){
            if(res.data){
              let resData = res.data.formResultBeanList;
              this.totals_data = res.data.total;
              this.totalPages_data = Math.ceil(res.data.total / this.size_data) - 1;
              if (resData == null || resData.length === 0) {
                this.finished_data = true;
                this.inList_data = [];
                return false;
              } else {
                if(resData&&resData.length>0){
                  resData.map((v)=>{
                    v.processInstanceId = v.processid
                    v.taskId = v.taskid
                  })
                }
                if (this.page_data > 0) {
                  this.inList_data = this.inList_data.concat(resData);
                } else {
                  this.inList_data = resData;
                }
                // 总条数和每页条数
                if (this.totals_data < this.size_data) {
                  this.finished_data = true;
                  return;
                }
                // 当前页和总页数
                if (this.page_data === this.totalPages_data) {
                  this.finished_data = true;
                  return false;
                }
              }
            }
          } else {
            this.$toast.fail(res.msg);
          }
        }
      })
    },
    // 查看网点
    getQuerySiteIdInfo(siteId) {
      if (siteId) {
        this.$router.push({path: '/techSiteId', query: {'siteId': siteId}});
      } else {
        this.$toast('无网点编号');
      }
    },

    // 任务详情
    getHistoryObjectData(processInstanceId) {
      if (!processInstanceId) {
        return
      }
      // this.$router.push({path:'/temp',query:{'processInstanceId':processInstanceId}});
      processTaskHistorical({
        processInstanceId: processInstanceId,
        handler: false
      }).then((res) => {
        if (res) {
          if (res.data) {
            if (res.data.code === 200) {
              if (res.data.data.historicActivityInstances && res.data.data.historicActivityInstances.length > 0) {
                res.data.data.historicActivityInstances.map((v) => {
                  if (v.formInfo.fields) {
                    v.formInfo.fields.map((i) => {
                      if (i.params.customDesign.type === 'fileupload') {
                        i.files = i.value ? i.value.split(',') : [];
                      } else if (i.params.customDesign.type === 'rate') {
                        i.value = parseInt(i.value) / 2;
                      }
                    })
                  }
                });
                this.submitText = '';
                this.formFields = [];
                this.returnObj = {};
                this.formDefine = {};
                this.historyList = res.data.data.historicActivityInstances;
                this.flagTemp = true;
              } else {
                this.historyList = [];
              }
            } else {
              this.$toast.fail(res.data.msg);
            }
          }
        }
      });
    },
    handleCheckUpdate(list) {
      this.formFields = list;
      console.log(this.formFields)
    },
    // 流程表单提交接口
    getTempReturn(data) {
      this.formFields = [];
      this.returnObj = {};
      this.formDefine = {};
      this.flagTemp = false;
      this.page1 = 0;
      this.page_data = 0;
      // // this.getListData();
      // this.innerLoading = true;
      // const TIME_COUNT = 3;
      // if (!this.timer) {
      //   this.count = TIME_COUNT;
      //   this.timer = setInterval(() => {
      //     if (this.count > 0 && this.count <= TIME_COUNT) {
      //       this.count--
      //       console.log(this.count,'秒')
      //     } else {
      this.getFlowClassifiedQuery();
      //       clearInterval(this.timer);
      //       this.timer = null;
      //       this.innerLoading = false;
      //     }
      //   }, 1000);
      // }

    },
    // 自动获取新站点编号
    // getNewSiteId(county) {
    //   if (!county) {
    //     this.$toast('没有详细地址！无法获取网点编号。');
    //     return false;
    //   }
    //   this.$http.installInfo_newSiteId({
    //     county: county,//this.returnObj.variables.address.split('/')[2]
    //   }).then((res) => {
    //     if (res) {
    //       this.newSiteId = res.toString();
    //     }
    //   });
    // },
    // 流程里面做完的流程历史数据
    historyObjectData(processInstanceId) {
      processTaskHistorical({
        processInstanceId: processInstanceId,
        handler: false
      }).then((res) => {
        if (res) {
          if (res.data) {
            if (res.data.code === 200) {
              if (res.data.data.historicActivityInstances && res.data.data.historicActivityInstances.length > 0) {
                res.data.data.historicActivityInstances.map((v) => {
                  if (v.formInfo.fields) {
                    v.formInfo.fields.map((i) => {
                      if (i.params.customDesign.type === 'fileupload') {
                        i.files = i.value ? i.value.split(',') : [];
                      } else if (i.params.customDesign.type === 'rate') {
                        i.value = parseInt(i.value) / 2;
                      }
                    })
                  }
                });
                this.historyList = res.data.data.historicActivityInstances;
              } else {
                this.historyList = [];
              }
            } else {
              this.$toast.fail(res.data.msg);
            }
          }
        }
      });
    },
    // 去处理任务
    getActiveItemInfo(item) {
      if (item.taskId) {
        // this.$router.push({path:'/temp',query:{'taskId':item.taskId,'processInstanceId':item.processInstanceId}});

        this.innerLoading = true;
        processNewdetails({
          taskId: item.taskId,
          processInstanceId: item.processInstanceId
        }).then((res) => {
          if (res) {
            if (res.data) {
              if (res.data.code === 200) {
                if (res.data.data && res.data.data.variables.processInstanceId) {
                  this.historyObjectData(res.data.data.variables.processInstanceId);
                }
                this.returnObj = res.data.data;
                this.taskId = item.taskId;
                let formDefine = JSON.parse(res.data.data.formDefine);
                if (formDefine) {
                  this.content = '';
                  this.submitText = '提交';
                  this.formDefine = formDefine;
                  if (formDefine.fields.length > 0) {
                    formDefine.fields.map((v) => {
                      v.id_name = '';
                      v.showItem = true;
                      if (v.id.indexOf('Name') !== -1) {
                        v.id_name = 'name'
                      } else if (v.id.indexOf('name') !== -1) {
                        v.id_name = 'name'
                      } else if (v.id.indexOf('phone') !== -1) {
                        v.id_name = 'phone'
                      } else if (v.id.indexOf('identity') !== -1) {
                        v.id_name = 'identity'
                      }
                      if (v.params.customDesign) {
                        v.value = '';
                        if (v.params.customDesign.type === 'fileupload') {
                          v.files = [];
                        } else if (v.params.customDesign.type === 'rate') {
                          v.socre = 0;
                          v.scoreValue = 0;
                          v.scoreValueFlag = true;
                        } else if (v.params.customDesign.type === 'date') {
                          v.dates = '';
                          v.dateValue = '';
                          v.dateValueFlag = true;
                        } else if (v.params.customDesign.type === 'select') {
                          // 复选框
                          if (v.params.customDesign.multiple) {
                            v.checkList = [];
                            v.checkName = [];
                          }
                        }
                      }
                    });
                    console.log('formDefine.fields', formDefine.fields)
                    this.formFields = formDefine.fields;
                    // // this.flowNameObj = item;
                    // // this.pDefinitionName = res.data.data.processDefinitionName;
                    // // 新装机，调取接口拿网点编号
                    // if (item.processInstanceName && item.processInstanceName === '新装机') {
                    //   if (!item.variables.siteid) {
                    //     this.getNewSiteId(res.data.data.variables.address.split('/')[2]);
                    //   }
                    // } else if (item.processDefinitionName && item.processDefinitionName === '新装机') {
                    //   if (!item.variables.siteid) {
                    //     this.getNewSiteId(res.data.data.variables.address.split('/')[2]);
                    //   }
                    // }
                    this.variablesObj = res.data.data.variables;
                    this.flagTemp = true;
                  }
                }
              }
              this.innerLoading = false;
            }
          }
        });
      }else{
        this.$toast('无taskId值');
        return false;
      }
    },
    // // 删除流程-开发人员使用
    // getApiDel(item) {
    //   processRemove({
    //     processInstanceId: item.processInstanceId
    //   }).then((res) => {
    //     if (res) {
    //       if (res.data) {
    //         if (res.data.code === 200) {
    //           this.page1 = 1;
    //           this.page_data = 1;
    //           this.getListData();
    //           this.getFlowClassifiedQuery();
    //         } else {
    //           this.$toast.fail(res.data.msg);
    //         }
    //       }
    //     }
    //   });
    // },
  }
}
</script>
<template>
  <div class="tech-content" @click="hide">
    <!--    加载中-->
    <inner-loading v-model="innerLoading"></inner-loading>
    <!--    动态表单模版-->
    <Temp v-model="flagTemp" v-if="flagTemp" content="close" :submitText="submitText" :variablesObj="variablesObj"
          :newSiteId="newSiteId" :flowNameObj="flowNameObj"
          :historyList="historyList" :siteIdObj="{}" :returnObj="returnObj" :formDefine="formDefine"
          :formFields.sync="formFields" @submit="getTempReturn" @checkbox="handleCheckUpdate"></Temp>
    <!-- 下载文件到邮箱 -->
    <sendEmail v-model="flagEmail" :variablesEmailObj="downObj" @submit="getEmailReturn"></sendEmail>
    <!--    <div class="tabs">-->
    <!--      <van-tabs v-model="activeTab" animated swipeable sticky>-->
    <!--        <van-tab :title="`待领取(${totals1})`" name="0"></van-tab>-->
    <!--        <van-tab :title="`未完成(${totals2})`" name="1"></van-tab>-->
    <!--      </van-tabs>-->
    <!--    </div>-->
    <div class="tabs" style="flex-direction: column">
      <van-field v-model="searchText" type="number" left-icon="search" placeholder="搜索网点编号/手机号" />
      <div class="tabs-select" @click.stop>
        <div class="tabs-flex">
          <div class="flex-title" @click="getSwitchStatue">{{statueTitle}}<van-icon name="arrow-down" color="#aaa" /></div>
          <div class="flex-data" v-show="statueFlag">
            <div class="flex-data-item" v-for="(item,index) in dataStatue" :class="itemStatue===index?'current':''" :key="index" @click="getCurrent(index,item)">{{item.title}}<van-icon v-if="itemStatue===index" name="success" color="#aaa" /></div>
          </div>
        </div>
        <div class="tabs-flex">
          <div class="flex-title" @click="getSwitchType">{{typeTitle}}<van-icon name="arrow-down" color="#aaa" /></div>
          <div class="flex-data" v-show="typeFlag">
            <div class="flex-data-item" v-for="(item,index) in dataType" :class="itemType===index?'current':''" :key="index" @click="getTypeCurrent(index,item)">{{item.title}}<van-icon v-if="itemType===index" name="success" color="#aaa" /></div>
          </div>
        </div>
        <div class="tabs-flex-text">
          <span class="rotate" @click="getSwitchDate">
            {{dateFlag?'时间倒序':'时间正序'}}<van-icon v-if="dateFlag" name="down" /><van-icon class="up-to-date" v-if="!dateFlag" name="down" />
          </span>
        </div>
      </div>
    </div>
    <!--    <div v-if="activeTab==='0'">-->
    <!--      <van-list v-model="loading1" :finished="finished1" :finished-text="finishedMsgTxt" :immediate-check="false"-->
    <!--                @load="onLoad">-->
    <!--        <div class="card" v-for="(item,index) in inList" :key="index">-->
    <!--          <div class="card-title">-->
    <!--            {{ item.arr_name }}-->
    <!--          </div>-->
    <!--          <div class="card-info">-->
    <!--            <div class="card-info-item">流程进度：{{ item.taskName }}</div>-->
    <!--          </div>-->
    <!--          <div class="card-info">-->
    <!--            <div class="card-info-item">网点编号：{{ item.variables.siteid }}</div>-->
    <!--            <div class="card-info-item">地区：{{ item.variables.city }}</div>-->
    <!--          </div>-->
    <!--          <div class="card-info">-->
    <!--            <div class="card-info-item" v-if="item.variables&&item.variables.name">姓名：{{ item.variables.name }}</div>-->
    <!--            <div class="card-info-item" v-if="item.variables&&item.variables.phone">电话：{{ item.variables.phone }}-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div class="card-footer">-->
    <!--            <div>开始时间：{{ item.startTime }}</div>-->
    <!--            <div>-->
    <!--              <button class="btns btn-secondary"-->
    <!--                      v-show="(item.variables&&item.variables.siteid)&&(item.arr_name!=='新装机'&&item.arr_name!=='网点录入')"-->
    <!--                      @click="getQuerySiteIdInfo(item.variables.siteid)">查看网点-->
    <!--              </button>-->
    <!--              <button class="btns btn-primary pd" @click="getActiveItemInfo(item)">去处理</button>-->
    <!--              &lt;!&ndash;              <button class="btns btn-primary pd" v-show="!item.variables.siteid" @click="getApiDel(item)">删除</button>&ndash;&gt;-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </van-list>-->
    <!--    </div>-->
    <!--    <div v-if="activeTab==='1'">-->
    <!--      <van-list v-model="loading2" :finished="finished2" :finished-text="finishedMsgTxt2" :immediate-check="false"-->
    <!--                @load="onLoad2">-->
    <!--        <div class="card" v-for="(item,index) in processHistory" :key="index">-->
    <!--          <div class="card-title">-->
    <!--            {{ item.arr_name }}-->
    <!--          </div>-->

    <!--          <div class="card-info">-->
    <!--            <div class="card-info-item">流程进度：{{ item.name }}</div>-->
    <!--          </div>-->
    <!--          <div class="card-info">-->
    <!--            <div class="card-info-item">网点编号：{{ item.variables.siteid }}</div>-->
    <!--            <div class="card-info-item">地区：{{ item.variables.city }}</div>-->
    <!--          </div>-->
    <!--          <div class="card-info">-->
    <!--            <div class="card-info-item" v-if="item.variables&&item.variables.name">姓名：{{ item.variables.name }}</div>-->
    <!--            <div class="card-info-item" v-if="item.variables&&item.variables.phone">电话：{{ item.variables.phone }}-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div class="card-footer">-->
    <!--            <div>开始时间：{{ item.created|formatDatetimeSub }}</div>-->
    <!--            <div>-->
    <!--              <button class="btns btn-secondary"-->
    <!--                      v-show="(item.variables&&item.variables.siteid)&&(item.arr_name!=='新装机'&&item.arr_name!=='网点录入')"-->
    <!--                      @click="getQuerySiteIdInfo(item.variables.siteid)">查看网点-->
    <!--              </button>-->
    <!--              <button class="btns btn-secondary" @click="getHistoryObjectData(item.processInstanceId)">任务详情</button>-->
    <!--              &lt;!&ndash;              <button class="btns btn-primary pd" @click="getActiveItemInfo(item)">去处理</button>&ndash;&gt;-->
    <!--              &lt;!&ndash;              <button class="btns btn-primary pd" v-show="!item.variables.siteid" @click="getApiDel(item)">删除</button>&ndash;&gt;-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </van-list>-->
    <!--    </div>-->
    <div style="padding-bottom: 20px">
      <van-list v-model="loading_data" :finished="finished_data" :finished-text="finishedMsgTxt_data" :immediate-check="false"
                @load="onLoad_data">
        <div class="card" v-for="(item,index) in inList_data" :key="index">
          <div class="card-title">
            {{ item.flowname }}
            <div v-if="item.fileName&&item.fileName.length>0">
              <span class="upload-btn mr" @click="getDownLoad(item)">下载</span>
            </div>
          </div>
          <div class="card-info">
            <div class="card-info-item">流程进度：{{ item.currentnodename }}</div>
          </div>
          <div class="card-info">
            <div class="card-info-item">网点编号：{{ item.siteid }}</div>
            <div class="card-info-item">地区：{{ item.city }}</div>
          </div>
          <div class="card-info">
            <div class="card-info-item" v-if="item.name">姓名：{{ item.name }}</div>
            <div class="card-info-item" v-if="item.phone">电话：{{ item.phone }}
            </div>
          </div>
          <div class="card-footer">
            <div class="time-size">开始时间：{{ item.createtime }}</div>
            <div>
              <button class="btns btn-secondary"
                      v-show="item.siteid&&(item.flowname!=='新装机'&&item.flowname!=='网点录入')"
                      @click="getQuerySiteIdInfo(item.siteid)">
                查看网点
              </button>
              <!-- state（0、待领取，1、已完成，2、未完成） -->
              <button class="btns btn-primary pd" v-if="item.state==='0'" @click="getActiveItemInfo(item)">去处理</button>
              <button class="btns btn-secondary" v-else @click="getHistoryObjectData(item.processInstanceId)">任务详情</button>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<style scoped lang="scss">
.tech-content {
  padding-top: 120px;
  box-sizing: border-box;
}
.tabs{
  overflow: inherit;
  padding:20px 15px 15px;
}
.tabs-select{
  display: flex;
  flex-direction: row;
  align-items: center;
  //justify-content:space-between;
  padding-top: 20px;
}
.van-cell{
  height: 70px;
  background: #f3f3f5;
  border-radius: 10px;
  padding-top: 10px;
  padding-left: 10px;
}
.tabs-flex-text{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 20%;
  font-size: 20px;
}
.tabs-flex{
  display: flex;
  padding:0 10px 10px 0;
  position: relative;
  width: 40%;
  .flex-title{
    display: flex;
    background: #f3f3f5;
    border-radius: 10px;
    padding:0 15px;
    height: 70px;
    width: 100%;
    font-size: 26px;
    align-items: center;
    justify-content: space-between;
  }
  .flex-data{
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 0;
    top: 80px;
    height: auto;
    width: 94%;
    margin: 0 1px;
    padding:10px 12px;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    .flex-data-item{
      padding: 10px;
      border-radius: 10px;
      display: flex;
      font-size: 26px;
      align-items: center;
      justify-content: space-between;
    }
    .current{
      background: #f3f3f5;
    }
  }
}
.up-to-date{
  transform: rotate(180deg);
}
.rotate{
  color: #aaa;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 25px;
}
.time-size{
  padding-top: 10px;
  font-size: 25px;
}

.upload-btn{
  background: #e62d2d;
  padding: 8px 20px;
  color: #fff;
  font-size: 24px;
  border-radius: 6px;
}
.bog{
  background: #f5f5f5;
  border: 2px solid #ddd;
  color: #666;
}
.mr{
  background: #1989fa;
  border: 2px solid #1989fa;
  margin-right: 10px;
  color: #fff;
}
</style>